module.exports = __webpack_public_path__ + "img/five_bg_girl.a030836a.png";